import { React, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./resetPass.module.css";
import axios from "axios";

const apiUrl = process.env.REACT_APP_URL;

const ResetPasswordForm = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const location = useLocation();
  const navigate = useNavigate();

  // The 'location' object contains information about the current URL.
  // 'location.search' returns the query string portion of the URL, including the question mark ('?').
  // For example, if the URL is 'http://example.com/reset_password?token=abc123', 'location.search' would be '?token=abc123'.
  const queryParams = new URLSearchParams(location.search);
  // The 'URLSearchParams' (built-in JS function) constructor parses the query string into an object-like structure
  // where each query parameter is a key-value pair.
  // The 'get' method of 'URLSearchParams' extracts the value of the 'token' parameter from the query string.
  const token = queryParams.get("token");

  const handleResetPassword = async (e) => {
    e.preventDefault();
    if (newPassword !== confirmPassword) {
      setMessage("Passwords do not match");
      return;
    }

    try {
      const res = await axios.post(`${apiUrl}/auth/reset_password`, {
        token,
        newPassword,
      });

      if (res.status === 200 && res.data.success) {
        setMessage("Password updated successfully. Redirecting to login...");
        setTimeout(() => {
          navigate("/login");
        }, 3000);
      } else {
        setMessage(res.data.message || "Failed to update password");
      }
    } catch (error) {
      setMessage("An error occurred. Please try again.");
      console.error("Reset password error:", error);
    }
  };

  return (
    <div className={styles.main}>
      <form className={styles.form} onSubmit={handleResetPassword}>
        <h2 className={styles.h2}>Reset Password</h2>

        <div className={styles.inputContainer}>
          <input
            type="password"
            placeholder="New Password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            required
          />
        </div>
        <div className={styles.inputContainer}>
          <input
            type="password"
            placeholder="Confirm New Password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            required
          />
        </div>

        <button className={styles.resetBtn} type="submit">
          Reset Password
        </button>

        {message && <p className={styles.message}>{message}</p>}
      </form>
    </div>
  );
};

export default ResetPasswordForm;
